import { put, takeEvery, delay } from 'redux-saga/effects';
import { showNotification } from 'react-admin';


function* fetchFailedSaga(action: any) {
  if (action.error.status === 403) {
    yield put(showNotification('ra.words.authorizationFailed', "error"));
    yield delay(4000)
    yield put(showNotification(action.error.message, "warning"));
  } else if (action.error.status === 500) {
    yield put(showNotification('ra.messages.internalServerError', "error"));
  }
}

export default function* apiSagas() {
  yield takeEvery("RA/FETCH_ERROR", fetchFailedSaga)
}
